'use client';

import { MuiButton } from '@/components/button/MuiButton';
import { Box, Typography } from '@mui/material';
import { useLogic } from './logic';
import { PasswordInputField } from '@/components/textfield/PasswordInputField';

type Props = {
  tmpToken: string;
};

export function ResetPasswordForm({ tmpToken }: Props) {
  const { control, onClickSubmit } = useLogic({ tmpToken });
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
        width: '400px',
        maxWidth: '90%',
        my: 6,
        mx: 'auto',
      }}
    >
      <Typography variant="JP/Heading/m/Bold/Tight" component="h1">
        新しいiBowログインパスワードを入力
      </Typography>
      <Box
        component="form"
        onSubmit={onClickSubmit}
        sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}
      >
        <PasswordInputField
          id={`reset-${control.register('password').name}`}
          key={control.register('password').name}
          name={control.register('password').name}
          control={control}
          label="新しいパスワード"
          required
        />
        <PasswordInputField
          id={`reset-${control.register('confirm_password').name}`}
          key={control.register('confirm_password').name}
          name={control.register('confirm_password').name}
          control={control}
          label="新しいパスワードを確認"
          required
        />
        <MuiButton type="submit">変更</MuiButton>
      </Box>
    </Box>
  );
}
